import { PaymentInstructionsResponse } from '@/DTOs/paymentInstruction';
import { PaymentRailType } from '@/types/currency';

export const mockPaymentInstructions: Record<string, PaymentInstructionsResponse> = {
  [PaymentRailType.ACH]: {
    receiverName: 'International Business Solutions and Financial Management Corporation LLC',
    receiverAddress:
      '456 Corporate Plaza, Suite 800, New York City, NY 10001, United States of America',
    receiverBankName: 'First National Bank of America',
    receiverBankAddress:
      '123 Financial District Avenue, Suite 1500, New York City, NY 10005, United States of America',
    accountNumber: '1234567890123456',
    routingNumber: '987654321',
    swiftCode: null,
    reference: 'REF123456789',
  },
  [PaymentRailType.Wire]: {
    receiverName: 'International Business Solutions and Financial Management Corporation LLC',
    receiverAddress:
      '456 Corporate Plaza, Suite 800, New York City, NY 10001, United States of America',
    receiverBankName: 'First National Bank of America',
    receiverBankAddress:
      '123 Financial District Avenue, Suite 1500, New York City, NY 10005, United States of America',
    accountNumber: '1234567890123456',
    routingNumber: '987654321',
    swiftCode: null,
    reference: 'REF123456789',
  },
  [PaymentRailType.Swift]: {
    receiverName: 'CURRENCY EXCHANGE INTERNATIONAL CORP',
    receiverAddress: '6675, Westwood Blvd, Orlando, FL 32821, US',
    receiverBankName: 'BMO HARRIS',
    receiverBankAddress: '320 S Canal St, Chicago, IL 60690, US',
    accountNumber: '44709159',
    routingNumber: '071000288',
    swiftCode: 'HATRUS44XXX',
    reference:
      'Swift Reference Field 70: MET CAP BANK FBO CFX FBO GLOBAL REMIT FINANCIAL SERVICES LTD FFC 269RK 100108059',
  },
};

// For backward compatibility
export const mockPaymentInstruction: PaymentInstructionsResponse =
  mockPaymentInstructions[PaymentRailType.ACH];
